// components
import { Popover } from 'components/mrp/components/Popover';
import EntitySearch from 'components/mrp/components/EntitySearch';

// styles
import { Label } from './EntityPickerLabel.styles';

// types
import type { EntityPickerLabelProps } from './EntityPickerLabel.types';
import type { PlanningEntityIdentifier } from 'generated/index';

// hooks
import { useNarrowedShortcutContexts } from 'components/shared/ShortcutProvider/ShortcutProvider.hooks';

// stores/context
import { useCalendarStore } from 'components/mrp/stores/calendarStore/calendarStore';
import { useShallow } from 'zustand/shallow';

export const EntityPickerLabel = ({
  calendarId,
  label,
  isPopoverOpen,
  setIsPopoverOpen
}: EntityPickerLabelProps) => {
  'use memo';
  const { entityIdsPerCalendarId, replaceCalendar } = useCalendarStore(
    useShallow((state) => ({
      entityIdsPerCalendarId: state.entityIdsPerCalendarId,
      openCalendar: state.control.openCalendar,
      replaceCalendar: state.control.replaceCalendar
    }))
  );

  useNarrowedShortcutContexts(isPopoverOpen);

  const openCalendarEntityIds = [
    ...new Set(Object.values(entityIdsPerCalendarId).flat())
  ];

  const handleOnChange = (entity: PlanningEntityIdentifier, label: string) => {
    if (!entity || !entity.entityId) return;

    const sources = [
      {
        label,
        planningEntityIdentifier: entity
      }
    ];

    replaceCalendar(calendarId, sources);
    setIsPopoverOpen(false);
  };

  return (
    <Popover
      id="entity-replace-and-search-popover"
      useForcedState={true}
      forceOpen={isPopoverOpen}
      onClose={() => setIsPopoverOpen(false)}
      component={
        <EntitySearch
          activeEntities={openCalendarEntityIds}
          minWidth={400}
          onChange={handleOnChange}
        />
      }
    >
      <Label variant="h6">{label}</Label>
    </Popover>
  );
};
